



























import { Vue, Prop, Component, Emit } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import CookieConsentCookiesBlock from './CookieConsentCookiesBlock.vue'
import { CookieCategoryStatus } from '../store/cookies/types'

@Component({
  components: {
    CookieConsentCookiesBlock
  }
})
export default class CookieConsentCategoryBlock extends Vue {
  @Prop() readonly id!: string
  @Prop() readonly isCGU!: boolean

  @Emit() change (value: boolean) { return value }
  @Action('COOKIES/changeValues') changeValues!: (cookieCategoryStatus: CookieCategoryStatus[]) => void

  get category () {
    return this.$store.getters['COOKIES/getCategory'](this.id)
  }

  get checked () {
    return this.category.checked
  }

  set checked (value) {
    this.changeValues([{ key: this.id, value: value }])
  }

  get description () {
    return this.isCGU ? this.category?.cgu_description : this.category?.description
  }
}
